import { graphql } from "react-relay";

import { OrgInvite } from "@components/org-invite";

export const fragments = {
  billingGroups: graphql`
    fragment BulkInvite_billingGroups on BillingGroupList {
      list {
        id
        name
        invitePolicy
        adminOrgPersons {
          __typename
          ... on OrgPersonList {
            list {
              isYou
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
  `,
  org: graphql`
    fragment BulkInvite_org on Org
    @argumentDefinitions(queryInput: { type: "String!", defaultValue: "" }) {
      id
      orgPersonListPaginatedErrorable(
        sortType: FullName
        sortDirection: Ascending
        searchQuery: $queryInput
        limit: 20
        excludeNonUsers: false
        freePersonsOnly: true
      ) {
        __typename
        ... on OrgPersonListPaginated {
          persons {
            personId
            primaryCalendarId
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  `,
};

export const query = graphql`
  query BulkInviteQuery($orgRelayId: ID!, $queryInput: String!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        id
        ...BulkInvite_org @arguments(queryInput: $queryInput)
        billingGroups {
          ... on BillingGroupList {
            ...BulkInvite_billingGroups
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
  }
`;
